export function formatSectorLabel(sectorId: string | null | undefined): string {
  if (!sectorId) return "Non attribué";
  const normalized = sectorId.trim();
  const internal = /^S(\d+)_(\d+)$/.exec(normalized);
  const publicId = /^A(\d+):S(\d+)$/.exec(normalized);
  const match = internal || publicId;
  if (!match) return normalized;
  return `Anneau A${Number(match[1])} · Secteur ${Number(match[2])}`;
}
